import { render, staticRenderFns } from "./StoresScroller.vue?vue&type=template&id=efc6491a&scoped=true"
import script from "./StoresScroller.vue?vue&type=script&lang=ts"
export * from "./StoresScroller.vue?vue&type=script&lang=ts"
import style0 from "./StoresScroller.vue?vue&type=style&index=0&id=efc6491a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc6491a",
  null
  
)

export default component.exports